// メニュートップ固定
$(function () {
    var $header = $('sticky-header.header-wrapper');
    $(window).scroll(function () {
        if ($(window).scrollTop() > 90) {
            $header.addClass('fixed')
        } else {
            $header.removeClass('fixed')
        }
    })
});
// 外部リンクにtarget追加
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
// contactのpowertedを消す
$(window).on("load", function() {
    var $globo = $('.wizard__content .panels+p');
    $globo.css('display','');
});
// ドロワー時headを白くする
$(function () {
  $('#Details-menu-drawer-container').click(function() {
    var p = $('#Details-menu-drawer-container').attr('open');
    if(!p){
      $('.header-wrapper').addClass('open');
    } else {
      $('.header-wrapper').removeClass('open');      
    }
  });
});
//
$(function(){
	$('iframe').on('load', function(){
		$('iframe').contents().find('head').append('<link rel="stylesheet" href="iframe.css" type="text/css">');
	});
});